<script>
  import AddClientNav from '../components/AddClient/AddClientNav.svelte';
  import General from '../components/AddClient/General.svelte';
  import ClientContact from '../components/AddClient/ClientContact.svelte';
  import ClientType from '../components/AddClient/ClientType.svelte';
  import RegistrationType from '../components/AddClient/RegistrationType.svelte';
  import Users from '../components/AddClient/Users.svelte';
  import FundProfile from '../components/AddClient/FundProfile.svelte';
  import OtherInformation from '../components/AddClient/OtherInformation.svelte';
  import ServiceProviderContact from '../components/AddClient/ServiceProviderContact.svelte';
  import LinkAttachServices from '../components/AddClient/LinkAttachServices.svelte';
  import ActiveEngagementType from '../components/AddClient/ActiveEngagementType.svelte';
  import { onMount, onDestroy, getContext } from 'svelte';
  import { client } from 'root/api/index.js';
  import * as yup from 'yup';
  import { createForm } from 'svelte-forms-lib';
  import { masterData, getMasterData } from '../stores/masterData.js';
  import { searchKeyByValue } from 'components/Helper.js';
  import Loader from '../components/Loader.svelte';
  import { navigate } from 'svelte-routing';
  import { setYupMessage, emptyStringToNull } from 'components/Helper.js';

  export let id = 0;
  let editClient = window.location.pathname.indexOf('edit') != -1;
  let activeTab = 'v-pills-general-tab';

  let selectedUnit = { id: '', name: '' };
  let unitMasterData;
  let units = undefined;
  let unitIds = {};
  let isFormPending = false;
  let serverErrors = [];

  let clientTypes = [];
  let clientSubTypes = {};

  let registrationTypes = [];
  let registrationSubTypes = {};
  let unitUsers = [];
  let userCategories = [];
  let projectTypes = [];
  let sows = [];
  let fundProfiles = [];
  let codeEthics = [];
  let legacyCompanyType = [];
  // let selectedClientId = [{
  //   label:null,
  //   types:null
  // }]
  let selectedClientId = [];

  let selectedRegistrationTypes = [];

  // let selectedRegistrationTypes = [{
  //   label:null,
  //   types:null
  // }]

  let selectedFundStrategy = [];
  let selectedCodeEthics = undefined;
  let selectedUsers = undefined;
  let clientTypeError = false;

  $: units && fetchDetail(id);

  const showDialog = getContext('showDialog');
  let selectUnitsInfo = {
    ukCompliance: false,
    outsourcedCfo: false,
    fundAdmin: false,
    usCompliance: false,
  };

  const setSelectUnitsInfo = (unitId) => {
    selectUnitsInfo.ukCompliance = unitIds.uk_compliance == unitId;
    selectUnitsInfo.outsourcedCfo = unitIds.outsourced_cfo == unitId;
    selectUnitsInfo.fundAdmin = unitIds.fund_admin == unitId;
    selectUnitsInfo.usCompliance = unitIds.us_compliance == unitId;
  };

  let states = [];
  const masterUnitUnsubscribe = masterData.subscribe((state) => {
    client.checkAuth().then(() => {
      if (state != undefined) {
        unitIds = getMasterData().unitId;
        units = getMasterData().units;
        userCategories = getMasterData().userCategories;
        states = getMasterData().states;
        legacyCompanyType = getMasterData().legacyCompanyTypeLabel;
      }
    });
  });

  onDestroy(() => {
    masterUnitUnsubscribe();
  });

  const getCurrentKey = () => {
    let links = document.querySelectorAll('#v-pills-tab a');
    var key = 0;
    for (var i in links) {
      if (i >= 0) {
        if (links[i].classList.contains('active')) {
          key = i;
        }
      }
    }
    return key;
  };

  const showBackNext = () => {
    let links = document.querySelectorAll('#v-pills-tab a');
    let key = getCurrentKey();
    showBack = key != 0;
    showNext = key != links.length - 1;
  };

  const clickBackNext = (flag) => {
    let links = document.querySelectorAll('#v-pills-tab a');
    let key = Number(getCurrentKey());
    let newKey = flag == 'back' ? key - 1 : key + 1;
    links[newKey].click();
  };

  onMount(() => {
    var triggerTabList = [].slice.call(document.querySelectorAll('#v-pills-tab a'));
    triggerTabList.forEach(function (triggerEl) {
      triggerEl.addEventListener('shown.bs.tab', function (event) {
        activeTab = event.target.id;
        showBackNext();
      });
    });
    showBackNext();
  });

  const keyboardListnerStatus = getContext('keyboardListnerStatus');
  onMount(() => {
    keyboardListnerStatus(true);
  });
  onDestroy(() => {
    keyboardListnerStatus(false);
  });

  let showBack = false;
  let showNext = false;

  let defaultValue = {
    id: '',
    name: '',
    unitCodeEthicsId: undefined,
    ongoing: 0,
    projectType: 0,
    ethicsOtherName: '',
    assetsManagement: '',
    employeesNo: '',
    notes: '',
    unitId: selectedUnit.id,
    contacts: [],
    clientTypes: [],
    registrationTypes: [],
    projectTypes: [],
    sows: [],
    users: [],
    urls: [],
    attachments: [],
    fundProfiles: [],
    serviceProviders: [],
    addresses: [],
    legacyCompanyType: '',
  };
  setYupMessage(yup);
  const { form, errors, handleChange, handleSubmit } = createForm({
    initialValues: { ...defaultValue },
    validationSchema: yup.object().shape({
      id: yup.string(),
      unitId: yup.string().required().nullable(),
      name: yup.string().required().nullable(),
      billingAddress: yup.string().nullable(),
      street: yup.string().nullable(),
      city: yup.string().nullable(),
      state: yup.string().nullable(),
      zip: yup.string().nullable(),
      country: yup.string().nullable(),
      unitCodeEthicsId: yup.string().nullable(),
      ethicsOtherName: yup
        .string()
        .nullable()
        .when('unitCodeEthicsId', {
          is: (value) => value == '',
          then: yup.string().required().nullable(),
        }),
      assetsManagement: yup.string().nullable(),
      employeesNo: yup
        .number('Enter whole number only')
        .integer('Enter whole number only')
        .transform(emptyStringToNull)
        .nullable(),
      notes: yup.string().nullable(),
      ongoing: yup.number().nullable(),
      projectType: yup.number().nullable(),
      addresses: yup.array().of(
        yup.object().shape({
          street: yup.string().nullable(),
          city: yup.string().nullable(),
          state: yup.string().nullable(),
          zip: yup.string().nullable(),
          country: yup.string().nullable(),
        }),
      ),
      contacts: yup.array().of(
        yup.object().shape({
          name: yup.string().nullable(),
          email: yup.string().email().nullable(),
          title: yup.string().nullable(),
          phone: yup.string().nullable(),
        }),
      ),
      clientTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          unitClientTypeId: yup.string(),
          subClientTypes: yup.array().of(
            yup.object().shape({
              id: yup.string(),
              unitClientTypeId: yup.number(),
            }),
          ),
        }),
      ),
      registrationTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          registrationNo: yup
            .string()
            .nullable()
            .when(['unitId'], {
              is: (value) =>
                $form.unitId == unitIds.uk_compliance || $form.unitId == unitIds.us_compliance,
              then: yup.string().nullable(),
            }),
          registrationUrl: yup
            .string()
            .nullable()
            .when('unitId', {
              is: (value) => $form.unitId == unitIds.us_compliance,
              then: yup.string().url().nullable(),
            }),
          unitRegistrationTypeId: yup.string().nullable(),
          subRegistrationTypes: yup.array().of(
            yup.object().shape({
              id: yup.string(),
              unitRegistrationTypeId: yup.number(),
            }),
          ),
        }),
      ),
      projectTypes: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          unitProjectTypeId: yup.number(),
          name: yup.string(),
          startDate: yup.string().when('projectType', {
            is: (value) => $form.projectType == 1,
            then: yup.string().required().nullable(),
          }),
          endDate: yup.string().when('projectType', {
            is: (value) => $form.projectType == 1,
            then: yup.string().nullable(),
          }),
        }),
      ),
      sows: yup.array().of(
        yup.object().shape({
          id: yup.string().nullable(),
          unitSowId: yup.string().nullable(),
          name: yup.string().nullable(),
          otherName: yup.string().nullable(),
        }),
      ),
      ongoingStartDate: yup.string().when('ongoing', {
        is: (value) => $form.ongoing == 1,
        then: yup.string().required().nullable(),
      }),
      ongoingEndDate: yup.string().nullable(),
      users: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          userId: yup.string(),
          firstName: yup.string(),
          lastName: yup.string(),
        }),
      ),
      urls: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          url: yup.string().url(),
        }),
      ),
      serviceProviders: yup.array().of(
        yup.object().shape({
          id: yup.string(),
          name: yup.string(),
          type: yup.string(),
          email: yup.string().email(),
          phone: yup.string(),
          notes: yup.string(),
        }),
      ),
      fundProfiles: yup.array().of(
        yup.object().shape({
          id: yup.string().nullable(),
          name: yup.string().nullable().required(),
          unitFundStrategyId: yup.string().nullable(),
          ccc: yup.string().nullable(),
          pmac: yup.string().nullable(),
          cik: yup.string().nullable(),
          passphrase: yup.string().nullable(),
          password: yup.string().nullable(),
          renewal: yup.string().nullable(),
          renewalDate: yup.string().when('renewal', {
            is: (value) => value == 1,
            then: yup.string().required().nullable(),
            otherwise: yup.string().nullable(),
          }),
          notes: yup.string().nullable(),
          blueskys: yup.array().of(
            yup.object().shape({
              id: yup.string().nullable(),
              stateId: yup.number(),
              date: yup.string().required().nullable(),
              name: yup.string().nullable(),
            }),
          ),
        }),
      ),
      legacyCompanyType: yup.string().nullable(),
    }),

    onSubmit: (values) => {
      clientTypeError = $form.clientTypes.length == 0;
      let errorMessage = '';
      if ($form.clientTypes.length == 0) {
        errorMessage += '\nPlease add at least one client type';
      }
      if ($form.registrationTypes.length == 0) {
        errorMessage += '\nPlease add at least one registration type';
      }
      if (errorMessage != '') {
        showDialog({ message: errorMessage });
        return;
      }
      let fundProfileArr = [];
      values.fundProfiles.map((item, index) => {
        let isBlueskysAdded = false;
        if (item.id > 0) {
          item.blueskys.map((blueskysItem, blueskysIndex) => {
            if (blueskysItem.date != '') {
              isBlueskysAdded = true;
            }
          });

          if (
            item.name != '' ||
            item.ccc != '' ||
            item.cik != '' ||
            item.notes != '' ||
            item.passphrase != '' ||
            item.password != '' ||
            item.pmac != '' ||
            item.renewal != '' ||
            (item.renewalDate != null && item.renewalDate != '') ||
            item.unitFundStrategyId > 0 ||
            isBlueskysAdded
          ) {
          } else {
            fundProfileArr.push(item);
          }
        }
      });

      if (fundProfileArr.length > 0) {
        showDialog({ message: 'Please Enter Fund Profile Info' });
      } else {
        if (isFormPending) {
          return;
        }
        let formData = getFormData(values);
        isFormPending = true;
        client
          .clientAdd(formData)
          .then((response) => {
            //navigate(`/client`,{ replace: true })
            navigate(`/redirect/client#action=viewClient&clientId=${response.data.id}`);
          })
          .catch((err) => {
            isFormPending = false;
            serverErrors = [err.message];
            showDialog({ message: serverErrors });
          });
      }
    },
  });

  const getFormData = (data) => {
    let values = { ...data };

    let contactsArr = [];
    values.contacts.map((item, index) => {
      if (item.name != '' || item.email != '' || item.title != '' || item.phone != '') {
        contactsArr.push(item);
      }
    });
    values.contacts = contactsArr;

    let clientArr = [];
    values.clientTypes.map((item, index) => {
      if (item.unitClientTypeId > 0) {
        clientArr.push(item);
      }
    });
    values.clientTypes = clientArr;

    let registrationArr = [];
    values.registrationTypes.map((item, index) => {
      if (
        item.unitRegistrationTypeId > 0 ||
        item.registrationUrl != '' ||
        item.registrationNo != ''
      ) {
        registrationArr.push(item);
      }
    });
    values.registrationTypes = registrationArr;

    let urlsArr = [];
    values.urls.map((item, index) => {
      if (item.url != '') {
        urlsArr.push(item);
      }
    });
    values.urls = urlsArr;

    let fundProfilesArr = [];
    values.fundProfiles.map((item, index) => {
      let isBlueskysAdded = false;
      item.blueskys.map((blueskysItem, blueskysIndex) => {
        if (blueskysItem.date != '') {
          isBlueskysAdded = true;
        }
      });

      if (
        item.name != '' ||
        item.ccc != '' ||
        item.cik != '' ||
        item.notes != '' ||
        item.passphrase != '' ||
        item.password != '' ||
        item.pmac != '' ||
        item.renewal != '' ||
        (item.renewalDate != null && item.renewalDate != '') ||
        item.unitFundStrategyId > 0 ||
        isBlueskysAdded
      ) {
        fundProfilesArr.push(item);
      }
    });
    values.fundProfiles = fundProfilesArr;

    let serviceProvidersArr = [];
    values.serviceProviders.map((item, index) => {
      if (
        item.name != '' ||
        item.email != '' ||
        item.notes != '' ||
        item.phone != '' ||
        item.type != ''
      ) {
        serviceProvidersArr.push(item);
      }
    });
    values.serviceProviders = serviceProvidersArr;
    return values;
  };

  const fetchDetail = (requestId) => {
    var edit = editClient && id > 0;
    id = requestId != undefined ? requestId : 0;
    if (edit) {
      client
        .clientGet({ id: id })
        .then((response) => {
          if (response.data.isEditable == false) {
            navigate('/invalid-access');
          }
          let clientTypes = response.data.clientTypes;
          let oldSelectedClientTypes = [];
          clientTypes.forEach((value, index) => {
            oldSelectedClientTypes.push({
              label: null,
              types: null,
            });
          });
          selectedClientId = oldSelectedClientTypes;

          let registrationTypes = response.data.registrationTypes;
          let oldSelectedRegistrationTypes = [];
          registrationTypes.forEach((value, index) => {
            oldSelectedRegistrationTypes.push({
              label: null,
              types: null,
            });
          });
          selectedRegistrationTypes = oldSelectedRegistrationTypes;

          // selectedUsers = response.data.users

          $form = response.data;
          selectedUnit = units[searchKeyByValue(units, 'id', $form.unitId)];
          if ($form.users.length == 0) {
            // selectedUsers = undefined
          }
          getUnitMaster($form.unitId, edit);
        })
        .catch((err) => {
          serverErrors = [err.message];
          showDialog({ message: serverErrors });
        });
    } else {
      defaultValue.unitId = id;
      $form = { ...defaultValue };
      selectedUnit = units[searchKeyByValue(units, 'id', $form.unitId)];
      getUnitMaster($form.unitId, edit);

      //  selectedClientId = [{
      //     label:null,
      //     types:null
      //   }]
      selectedClientId = [];

      //  selectedRegistrationTypes = [{
      //     label:null,
      //     types:null
      //   }]

      selectedRegistrationTypes = [];

      selectedFundStrategy = [];
      selectedCodeEthics = undefined;
    }
  };
  let serviceProviderTypes = [];
  const getUnitMaster = (unitId, edit) => {
    setSelectUnitsInfo(unitId);
    client
      .getUnitMasterData({
        unitId,
        fundProfilesRequired: $form.fundProfiles,
        unitCodeEthicsIdRequired: $form.unitCodeEthicsId,
        registrationTypesRequired: $form.registrationTypes,
        serviceProviders: $form.serviceProviders,
        clientTypesRequired: $form.clientTypes,
      })
      .then((result) => {
        unitMasterData = result.data;

        serviceProviderTypes = [...unitMasterData.serviceProviderTypes, { id: '', name: 'Other' }];
        clientTypes = unitMasterData.clientTypes;
        clientTypes.forEach((value) => {
          clientSubTypes[value.id] = value.subClientTypes;
        });

        registrationTypes = unitMasterData.registrationTypes;
        registrationTypes.forEach((value) => {
          registrationSubTypes[value.id] = value.subRegistrationTypes;
        });

        projectTypes = unitMasterData.projectTypes;
        sows = unitMasterData.sows;
        fundProfiles = unitMasterData.fundProfiles;
        codeEthics = unitMasterData.codeEthics;
        codeEthics.push({ id: '', name: 'Other' });

        if (edit) {
          let oldSelectedClientId = selectedClientId;
          if ($form.clientTypes.length > 0) {
            $form.clientTypes.forEach((value, index) => {
              let parentKey = searchKeyByValue(clientTypes, 'id', value.unitClientTypeId);
              let currentLabel = null;
              let currentType = null;
              if (parentKey != -1) {
                currentLabel = clientTypes[parentKey];
                // let arr = []
                // value.subClientTypes.forEach((sabValue, subIndex)=>{
                //   arr.push({unitClientTypeId : sabValue.unitClientTypeId , name : sabValue.name})
                // })

                if (value.subClientTypes != undefined && value.subClientTypes.length > 0) {
                  let subArr = [];
                  value.subClientTypes.forEach((subvalue, subindex) => {
                    let childKey = searchKeyByValue(
                      clientTypes[parentKey].subClientTypes,
                      'id',
                      subvalue.unitClientTypeId,
                    );
                    if (childKey != -1) {
                      subArr.push(clientTypes[parentKey].subClientTypes[childKey]);
                    }
                  });
                  currentType = subArr;
                }
              }
              oldSelectedClientId[index].label = currentLabel;
              oldSelectedClientId[index].types = currentType;
            });
          }
          selectedClientId = oldSelectedClientId;

          let oldSelectedRegistrationTypes = selectedRegistrationTypes;
          if ($form.registrationTypes.length > 0) {
            $form.registrationTypes.forEach((value, index) => {
              let parentKey = searchKeyByValue(
                registrationTypes,
                'id',
                value.unitRegistrationTypeId,
              );
              let currentLabel = null;
              let currentType = null;
              if (parentKey != -1) {
                currentLabel = registrationTypes[parentKey];
                if (
                  value.subRegistrationTypes != undefined &&
                  value.subRegistrationTypes.length > 0
                ) {
                  let subArr = [];
                  value.subRegistrationTypes.forEach((subvalue, subindex) => {
                    let childKey = searchKeyByValue(
                      registrationTypes[parentKey].subRegistrationTypes,
                      'id',
                      subvalue.unitRegistrationTypeId,
                    );
                    if (childKey != -1) {
                      subArr.push(registrationTypes[parentKey].subRegistrationTypes[childKey]);
                    }
                  });
                  currentType = subArr;
                }
              }
              oldSelectedRegistrationTypes[index].label = currentLabel;
              oldSelectedRegistrationTypes[index].types = currentType;
            });
          }
          selectedRegistrationTypes = oldSelectedRegistrationTypes;

          for (var i in $form.fundProfiles) {
            selectedFundStrategy[i] =
              fundProfiles[
                searchKeyByValue(fundProfiles, 'id', $form.fundProfiles[i].unitFundStrategyId)
              ];
          }

          if ($form.ethicsOtherName != null && $form.ethicsOtherName != '') {
            selectedCodeEthics = { id: '', name: 'Other' };
          } else {
            selectedCodeEthics =
              codeEthics[searchKeyByValue(codeEthics, 'id', $form.unitCodeEthicsId)];
          }
        }
        getUnitUser(unitId);
      })
      .catch((err) => {
        showDialog({ message: err.message });
        resetUnitMasterData();
      });
  };

  const getUnitUser = (unitId) => {
    client
      .unitUsers({ units: [{ unitId }], requireIds: $form.users })
      .then((result) => {
        unitUsers = result.data.users;
        if ($form.users != null && $form.users.length > 0) {
          selectedUsers = [];
          let oldSelectedUsers = [];
          for (var i in $form.users) {
            var userKey = searchKeyByValue(unitUsers, 'userId', $form.users[i].userId);
            unitUsers[userKey].id = $form.users[i].id;
            oldSelectedUsers.push(unitUsers[userKey]);
          }
          selectedUsers = oldSelectedUsers;
        }
      })
      .catch((err) => {
        showDialog({ message: err.message });
      });
  };

  const resetUnitMasterData = () => {
    clientTypes = [];
    registrationTypes = [];
    clientSubTypes = [];
    registrationSubTypes = [];
    unitUsers = [];
    projectTypes = [];
    sows = [];
    fundProfiles = [];
    states = [];
    codeEthics = [];
  };
</script>

<div class="mh-100 h-100">
  <div class="d-flex h-100 w-100 p-3 flex-column container">
    <div class="block-header mb-2">
      <div class="row align-items-center">
        <div class="col">
          <h2 class="page-title">
            {$form.id != undefined && $form.id > 0 ? 'Edit' : 'Add'}
            Client
          </h2>
        </div>
      </div>
    </div>
    <div class="page-content card-content bg-white h-100">
      <div class="h-100 d-flex flex-row">
        <div class="h-100">
          <AddClientNav
            errors={errors}
            selectUnitsInfo={selectUnitsInfo}
          />
        </div>
        <div class="page-content p-3 pt-0">
          <div class="d-flex flex-column h-100">
            <div class="page-content">
              <div
                class="tab-content w-100 h-100 flex-column"
                id="v-pills-tabContent"
              >
                <div
                  class="tab-pane fade show active"
                  id="v-pills-general"
                  role="tabpanel"
                  aria-labelledby="v-pills-general-tab"
                >
                  <General
                    form={form}
                    errors={errors}
                    handleChange={handleChange}
                    units={units}
                    selectedUnit={selectedUnit}
                  />
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-contacts"
                  role="tabpanel"
                  aria-labelledby="v-pills-contacts-tab"
                >
                  {#if activeTab === 'v-pills-contacts-tab'}
                    <ClientContact
                      form={form}
                      errors={errors}
                      handleChange={handleChange}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-client"
                  role="tabpanel"
                  aria-labelledby="v-pills-client-tab"
                >
                  {#if activeTab === 'v-pills-client-tab'}
                    <ClientType
                      handleChange={handleChange}
                      form={form}
                      errors={errors}
                      clientTypes={clientTypes}
                      unitIds={unitIds}
                      clientSubTypes={clientSubTypes}
                      selectedClientId={selectedClientId}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane h-100 fade"
                  id="v-pills-registration"
                  role="tabpanel"
                  aria-labelledby="v-pills-registration-tab"
                >
                  {#if activeTab === 'v-pills-registration-tab'}
                    <RegistrationType
                      form={form}
                      errors={errors}
                      registrationTypes={registrationTypes}
                      selectedRegistrationTypes={selectedRegistrationTypes}
                      registrationSubTypes={registrationSubTypes}
                      handleChange={handleChange}
                      selectUnitsInfo={selectUnitsInfo}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-active"
                  role="tabpanel"
                  aria-labelledby="v-pills-active-tab"
                >
                  {#if activeTab === 'v-pills-active-tab'}
                    <ActiveEngagementType
                      form={form}
                      errors={errors}
                      projectTypes={projectTypes}
                      sows={sows}
                      handleChange={handleChange}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-users"
                  role="tabpanel"
                  aria-labelledby="v-pills-users"
                >
                  {#if activeTab === 'v-pills-users-tab'}
                    <Users
                      form={form}
                      errors={errors}
                      users={unitUsers}
                      userCategories={userCategories}
                      selectedUsers={selectedUsers}
                      selectUnitsInfo={selectUnitsInfo}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-link-attach"
                  role="tabpanel"
                  aria-labelledby="v-pills-link-attach"
                >
                  {#if activeTab === 'v-pills-link-attach-tab'}
                    <LinkAttachServices
                      form={form}
                      errors={errors}
                      setIsFormPending={(isFormPendingRequest) =>
                        (isFormPending = isFormPendingRequest)}
                      handleChange={handleChange}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane page-content h-100 fade"
                  id="v-pills-fund-profile"
                  role="tabpanel"
                  aria-labelledby="v-pills-fund-profile"
                >
                  {#if activeTab === 'v-pills-fund-profile-tab'}
                    <FundProfile
                      form={form}
                      errors={errors}
                      handleChange={handleChange}
                      fundProfiles={fundProfiles}
                      states={states}
                      selectedFundStrategy={selectedFundStrategy}
                      selectUnitsInfo={selectUnitsInfo}
                    />
                  {/if}
                </div>
                <div
                  class="tab-pane fade"
                  id="v-pills-other-info"
                  role="tabpanel"
                  aria-labelledby="v-pills-other-info"
                >
                  <OtherInformation
                    form={form}
                    errors={errors}
                    handleChange={handleChange}
                    codeEthics={codeEthics}
                    selectUnitsInfo={selectUnitsInfo}
                    selectedCodeEthics={selectedCodeEthics}
                    legacyCompanyType={legacyCompanyType}
                  />
                </div>

                {#if !selectUnitsInfo.outsourcedCfo}
                  <div
                    class="tab-pane fade"
                    id="v-pills-service-provider"
                    role="tabpanel"
                    aria-labelledby="v-pills-service-provider"
                  >
                    {#if activeTab === 'v-pills-service-provider-tab'}
                      <ServiceProviderContact
                        form={form}
                        errors={errors}
                        serviceProviderTypes={serviceProviderTypes}
                        handleChange={handleChange}
                      />
                    {/if}
                  </div>
                {/if}
              </div>
            </div>
            <div class="mt-3 d-flex align-items-center justify-content-between">
              <button
                on:click={() => {
                  navigate(`/client`, { replace: true });
                }}
                class="trans-btn mb-0 px-3 font-size-12 outline-0 btn-cancel me-2">Cancel</button
              >

              <button
                type="submit"
                on:click={handleSubmit}
                class="btn background-blue mb-0 text-white px-4 add-task font-size-12 btn-primary"
              >
                {#if isFormPending}
                  <Loader />
                {:else}
                  <span class="color-white font-size-12 font-weight-400"> Save </span>
                {/if}
              </button>

              <div>
                <button
                  disabled={showBack == false}
                  on:click={() => {
                    clickBackNext('back');
                  }}
                  class="trans-btn btn mb-0 px-3 font-size-12 outline-0 btn-cancel me-2"
                >
                  Back
                </button>
                <button
                  disabled={showNext == false}
                  on:click={() => {
                    clickBackNext('next');
                  }}
                  class="trans-btn btn mb-0 px-3 font-size-12 outline-0 btn-cancel me-2"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
